import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import { jbColors } from 'theme/jbColors';
import { DefinedContext } from 'views/Accounts/IndexBalanced/DefinedContext';
import { getAccountProductDetails } from 'services/product-service/getAccountProductDetails';
import { closeModal, openModal } from 'reducers/modalReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { selectAccountNumber } from 'selectors/accountSelector';
import { setAccountSelectedProduct } from 'reducers/accountReducer';
import { IndexBalancedActions } from 'views/Accounts/IndexBalanced/IndexBalancedActions';
import { ProductServiceDetailsResponse } from 'pco-product-service-internal-consumer';

const styles = {
  container: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
  divider: {
    flex: 1,
    borderColor: jbColors.core.reflexBlue[40],
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
};

type Props = {
  productId?: string;
};
export const IndexBalanced = ({ productId }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accountNumber = useSelector(selectAccountNumber);
  const [productDetails, setProductDetails] = useState<ProductServiceDetailsResponse>({});
  const [isLoading, setIsLoading] = useState(true);
  const fetchKey = `${accountNumber ?? ''}|${productId ?? ''}`;
  const [prevFetchKey, setPrevFetchKey] = useState(fetchKey);
  if (fetchKey !== prevFetchKey) {
    setPrevFetchKey(fetchKey);
    if (productId && accountNumber) {
      setIsLoading(true);
    }
  }

  useEffect(() => {
    if (!productId || !accountNumber) return;
    let cancelled = false;
    void (async () => {
      try {
        const response = await getAccountProductDetails(accountNumber, productId);
        if (cancelled) return;
        setIsLoading(false);
        setProductDetails(response);
      } catch (error: unknown) {
        if (cancelled) return;
        dispatch(
          openModal({
            modalType: 'JBErrorModalWrapper',
            modalProps: {
              httpError: error,
              okHandler: () => {
                navigate(`/accounts?accountNumber=${accountNumber}`);
                dispatch(setAccountSelectedProduct(undefined));
                dispatch(closeModal());
              },
              technicalInfo: {
                title: 'Error when retrieving Product information',
                userErrorMessage: 'An error occurred when retrieving Product information. Please try again later.',
              },
            },
          }),
        );
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [accountNumber, productId, dispatch, navigate]);

  return (
    <>
      <Grid sx={styles.container}>
        <Typography sx={styles.title} variant="h1">
          INDEX +, BALANCED
        </Typography>
        <DefinedContext isLoading={isLoading} item={productDetails} />
      </Grid>
      <IndexBalancedActions />
    </>
  );
};
